import React from 'react';
import { MetricGrid } from '@/shared/components/patterns';
import { ASSIGNMENTS_STATS_CONFIG } from '@/modules/deals/utils';

const statsPresentation = {
  pending: {
    label: 'Da Accettare',
    iconKey: 'metrics.pending',
    tone: 'neutral',
  },
  inProgress: {
    label: 'In Corso',
    iconKey: 'metrics.inProgress',
    tone: 'progress',
  },
  completed: {
    label: 'Completati',
    iconKey: 'metrics.completed',
    tone: 'success',
  },
  overdue: {
    label: 'Scadute',
    iconKey: 'metrics.overdue',
    tone: 'attention',
  },
};

const statsOrder = ['pending', 'inProgress', 'completed', 'overdue'];

const statsTabMap = {
  pending: 'da_accettare',
  inProgress: 'in_corso',
  completed: 'completati',
  overdue: 'scadute',
};

export default function AssignmentsStats({ stats, activeMetric, onMetricClick }) {
  const metrics = statsOrder
    .map((key) => {
      const item = ASSIGNMENTS_STATS_CONFIG.find((config) => config.key === key) || { key };
      const presentation = statsPresentation[key] || {};
      return {
        id: key,
        label: presentation.label || item.title,
        value: `${stats[key] || 0}`,
        iconKey: presentation.iconKey,
        tone: presentation.tone,
        active: activeMetric === statsTabMap[key],
        onClick: onMetricClick ? () => onMetricClick(statsTabMap[key]) : undefined,
      };
    });

  return <MetricGrid metrics={metrics} />;
}
